import { render, staticRenderFns } from "./incomeSupplement.vue?vue&type=template&id=4e25b381&scoped=true"
import script from "./incomeSupplement.vue?vue&type=script&lang=ts"
export * from "./incomeSupplement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25b381",
  null
  
)

export default component.exports